import _, { matches } from 'lodash';
import { createContext, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { Button, Icon, Menu, Sidebar } from 'semantic-ui-react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { convertHelpers, getGoogleSheetDataValues } from '../../../../global/common/convert';
import { uniqueKey } from '../../../../global/common/keys';
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons';
import DataSidebar from '../../../../global/components/swipers/DataSidebar';
import JsonViewer from '../../../../global/components/viewers/JsonViewer';
import { gEnums } from '../../../../global/enums/globalEnums';
import { newPropEditItem } from '../../../../global/viewSettings/helpers/settingsHelpers';
import { openExternal } from '../../../../global/viewSettings/helpers/settingsLinks';
import FullPageWrapper from '../../../../global/wrappers/FullPageWrapper';
import TransitionWrapper from '../../../../global/wrappers/TransitionWrapper';
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper';
import WrapperVertCols from '../../../../global/wrappers/WrapperVertCols';
import { SportsDistrictContext } from '../../cnr/contexts/SportsDistrictContext';
import SportsEditMatchProvider, { SportsEditMatchContext } from '../../cnr/contexts/SportsEditMatchContext';
import SportsMatchProvider from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext, _sportsFormProps } from '../../cnr/contexts/SportsSeasonContext';
import { seasonalUpdateTypes } from '../../cnr/reducers/reducerHelpers/seasonalSportsData';
import { getLevelMatchez } from '../../cnr/reducers/reducerHelpers/seasonSportsData';
import { sportsHelpers } from '../../cnr/reducers/reducerHelpers/sportsHelpers';
import { matchStatusTypes, sportsDataHandlers, sportsDataInitialState, sportsDataReducer } from '../../cnr/reducers/SportsDataReducer';
import { realtimeDocumentTypes } from '../../cnr/reducers/SportsEditMatchReducer';
import { _sportCollections } from '../../cnr/reducers/SportsSidebarReducer';
import { realTimeScoring } from '../../dbActions/realtimeScoring';
import { fsfn_sports } from '../../functions/fbSportsFuntions';
import { _sdm } from '../dashboard/SportsDashboard';
import TeamList from '../teams/TeamList';
import MatchDetailsUpdate from './MatchDetailsUpdate';
import MatchesUpdateViewer from './MatchesUpdateViewer';
import { LevelSchedules } from '../schedule/LevelSchedules';
import NoData from 'global/components/alerts/NoData';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares ';
import { useGoogleSports } from 'projectSpecific/sports/useHelpers/useGoogleSports';

const _csv_match = ['id', '_itemKey', 'startDate', 'section', 'level', 'away', 'awayScore', 'home', 'homeScore', 'extra', 'oldStartDate', 'postponed', 'cancelled', 'exhibition', 'remove', 'matchFlip']
const _csv_matchPlayoff = ['id', 'startDate', 'startTime', 'level', 'poolKey', 'matchNumber', 'location', 'awaySeed', 'away', 'awayScore', 'homeSeed', 'home', 'homeScore', 'away1', 'home1', 'away2', 'home2', 'away3', 'home3', 'away4', 'home4', 'away5', 'home5']
const _csvr_results = ['name', 'levels', 'sections', 'mp', 'sw', 'sl', 'w', 'l', 'swp', 'owp', 'sectionRank', 'playoffRank']

const _leftModes = {
  showOptions: 'showOptions',
  showYears: 'showYears',
}

export const _rightModes_mdu = {
  backupMatches: 'backupMatches',
  backupPlayoffMatches: 'backupPlayoffMatches',
  backupScores: 'backupScores',
  confirmRankings: 'confirmRankings',
  confirmPending: 'confirmPending',
  confirmResults: 'confirmResults',
  confirmResults_haFlip: 'confirmResults_haFlip',
  confirmClearResults: 'confirmClearResults',
  confirmMatchDayResults: 'confirmMatchDayResults',
  confirmClearMatchDayResults: 'confirmClearMatchDayResults',
  confirmScores: 'confirmScores',
  exportPlayoffResults: 'exportPlayoffResults',
  exportPlayoffResultsMedia: 'exportPlayoffResultsMedia',
  exportResults: 'exportResults',
  exportResultsMedia: 'exportResultsMedia',
  exportStandings: 'exportStandings',
  repairResults: 'repairResults',
  updateMatchDayResults: 'updateMatchDayResults',
  updatePlayoffMatchDayResults: 'updatePlayoffMatchDayResults',
  matchLocations: 'matchLocations',
  matchTime: 'matchTime',
}

const _openModes = {
  database: 'database',
  realtimeDb: 'realtimeDb',
  googleSheets: 'googleSheets',
  media: 'media',
}

const _mediaModes = {
  results: 'results',
  playoffResults: 'playoffResults',
}

export const _fetchModes = {
  results: 'results',
  playoffResults: 'playoffResults',
  resultsMedia: 'resultsMedia',
  playoffResultsMedia: 'playoffResultsMedia',
  wpialResults: 'wpialResults',
}

const _ignoreNoMid = true

export const MatchDataUpdateContext = createContext();

const MatchDataUpdate = (props) => {

  const { sportsDataMode, forSportsManagement, fromApp, handleCancel, currentMenuKey } = props

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, fn_cls } = parentContext ?? {}
  const { app_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { mainRt, mainDb } = app_state

  const database_fns = _.get(parentContext, 'fns.database_fns')

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data, sportPermissions } = sportsDistrict_state ?? {}
  const { gls_scores } = district_data ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}

  const googleSports = useGoogleSports({ currentMenuKey, sportsDataMode })

  const {
    details_info,
    gameScoringType,
    currentSeason_info,
    links_score,
    matches_info,
    parentDataKeys,
    sportsShowOptions,
    sportDataSettings,
    teams_info,
    _sportsSeasonType,
    sportSettings_info,
  } = sportsSeason_state ?? {}

  const { useScoringCollection, useScoringCollectionOnly } = sportSettings_info ?? {}
  const { latestSeason, sportsKey, _sportsYearAbr, _sportsAbr, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}

  const _matches_info = matches_info;
  const { matches_groupInfo, matches_matchDay, matchPlayoffPendings: matchPlayoffPendings_season } = _matches_info ?? {};
  const { levelDateGroups, matches_combined } = matches_groupInfo ?? {};

  const flattenTeams = (teams) =>
    _.mapValues(teams, (team) => {
      const { record = {}, ...rest } = team
      const _team = {
        name: team.name,
        sections: team.sections,
        levels: team.levels,
      }
      const _record = {
        mp: record.mp, // matches played
        l: record.l, // losses
        w: record.w,
        sl: record.l,
        sw: record.sw,
        owp: record.owp.toFixed(2),
        swp: record.swp.toFixed(2),
        sectionRank: record.sectionRank,
        playofFRank: record.playofFRank,
        smp: record.smp,
        tm: record.tm,
      }
      return {
        ..._team,
        ..._record
      }
    })

  const sortTeams = (teamsList) =>
    _.orderBy(
      teamsList,
      ['levels', 'sections', 'sectionRank'],
      ['desc', 'asc', 'asc']
    )


  const missingMatches = _.filter(matches_combined, match =>
    _.get(match, '_status.isMissing') === true &&
    _.isNil(_.get(match, '_results_matchDay')) // exclude if it has a value
  );

  const _counts = {
    matches: _.size(_matches_info?.matches),
    matches_combined: _.size(_matches_info?.matches_combined),
    matches_matchDay: _.size(_matches_info?.matches_matchDay),
    missing: _.size(missingMatches),
  }

  const matchDayMatches = matches_combined && matches_matchDay ? _.pick(matches_combined, Object.keys(matches_matchDay)) : {};
  const _matchDayMatchKeys = matchDayMatches ? _.keys(matchDayMatches) : []

  const { matches: pks_matches_seasonal } = parentDataKeys ?? {}
  const { details } = details_info ?? {}
  const { firstPlayDate, seasonStartDate } = details ?? {}
  const { matchDate } = sportsShowOptions ?? {}

  // sportsEditMatchContext
  const sportsEditMatchContext = useContext(SportsEditMatchContext)
  const { sportsEditMatch_state } = sportsEditMatchContext ?? {}
  const { matchPendingUpdate } = sportsEditMatch_state ?? {}
  const { matchUpdateType } = matchPendingUpdate ?? {}

  // sportsData
  const init_state = {
    database_fns,
    fn_cls,
    gameScoringType,
    latestSeason,
    links_score,
    mainDb,
    matches_info,
    pathViews,
    sportPermissions,
    sportsKey,
    teams: teams_info && teams_info.teams,
    useScoringCollection,
    useScoringCollectionOnly,
  }

  const [sportsData_state, sportsData_dispatch] = useReducer(sportsDataReducer, init_state, sportsDataInitialState)
  const sportsData_handlers = sportsDataHandlers(sportsData_dispatch, sportsData_state)
  const _glsScore = gls_scores && sportsKey ? gls_scores[sportsKey] : null
  const { scoreEmails } = links_score ?? {}

  const {
    confirmation,
    filterType,
    forPlayoffs,
    matchData_match,
    matches_flat,
    matchPlayoffPendings,
    matchResultsInfo,
    rankings_info: rankings_info_data,
    showMatchProp,
    matchProp,
    updating,
  } = sportsData_state ?? {}

  let btn_prefix = 'Update';

  switch (filterType) {
    case matchStatusTypes.season:
    case matchStatusTypes.seasonPlayoff:
      btn_prefix = 'Refresh'
      break;
    default:
      btn_prefix = 'Update'
  }

  const _updateCaption_results = forPlayoffs ? btn_prefix + ' Playoff Results' : btn_prefix + ' Results'

  const {
    matchUpdates_data, // for db 
    matches_gs,
    matchDayUpdates,
    matchUpdates, // straight matches 
  } = matchResultsInfo ?? {}

  const { values, filtered, counts } = matches_flat ?? {}
  const { season: matches_flat_season, playoffs: matches_flat_playoff } = values ?? {}
  const { all: matches_flat_filtered } = filtered ?? {}
  const { filtered: filtered_count } = counts ?? {}


  const _updateCaption_clearResults = forPlayoffs ? 'Clear Playoff Results' : 'Clear Results'
  const _updateCaption_scores = forPlayoffs ? 'Update Playoff Scores' : 'Update Scores'
  const _updateCaption_backupScores = forPlayoffs ? 'Backup Playoff Scores' : 'Backup Scores'
  const _updateCaption_backupMatches = 'Backup Matches'
  const _updateCaption_backupPlayoffMatches = 'Backup Playoff Matches'

  const _matches_flat = forPlayoffs ? matches_flat_playoff : matches_flat_season

  const [appFormItems, setAppFormItems] = useState()
  const [currentYear, setCurrentYear] = useState()
  const [dateGroupKeyz, setDateGroupKeyz] = useState()
  const [formProps, setFormProps] = useState()
  const [linkValues, setLinkValues] = useState({})
  const [mode_gsTab, setMode_gsTab] = useState()
  const [mode_left, setMode_left] = useState()
  const [mode_right, setMode_right] = useState()
  const [repairedMatches, setRepairedMatches] = useState()
  const [showConfirmation_rankings, setShowConfirmation_rankings] = useState()
  const [updatingGs, setUpdatingGs] = useState()
  const [updatingLocal, setUpdatingLocal] = useState()
  const [selectedIndex, setSelectedIndex] = useState(0)

  const { mediaUrl } = linkValues ? linkValues : {}

  const _updateStatus_results = sportPermissions?.any && sportPermissions?.matchesList ? true : false

  const { standings_flat } = useMemo(() => {
    const _teamFlat = flattenTeams(teams_info.teams)
    const _teamsSort = sortTeams(_teamFlat)
    return { standings_flat: _teamsSort }
  })

  const addDates = (startDateString) => {

    const startDate = new Date(startDateString);

    // Number of days to add
    const daysToAdd = 14;

    // Initialize an array to store the resulting dates
    const resultDates = [];

    for (let i = 1; i <= daysToAdd; i++) {
      // Create a new date by adding 'i' days to the start date
      const newDate = new Date(startDate);
      newDate.setDate(startDate.getDate() + i);

      const newMonth = newDate.getMonth() + 1; // Adjust month to be 1-based
      const newDay = newDate.getDate();
      const newYear = newDate.getFullYear();

      // Format the new date as 'mm/dd/yyyy'
      const formattedDate = `${newMonth.toString().padStart(2, '0')}/${newDay.toString().padStart(2, '0')}/${newYear}`;

      resultDates.push(formattedDate);
    }

    return resultDates
  }

  useEffect(() => {
    const invalidMatches = _.pickBy(matches_combined, (match) => {
      const home = _.get(match, 'results.score.home');
      const away = _.get(match, 'results.score.away');
      return _.isNaN(home) || _.isNaN(away);
    });

    if (invalidMatches) {
      const _invalidMatches = _.cloneDeep(invalidMatches)
      _.forEach(_invalidMatches, (match) => {
        delete match.results;
      });
      const _gpp = _.groupBy(_invalidMatches, '_matchCollectionKey')
      const _invalidUpdates = {}
      _.forEach(_gpp, (gp, gppKey) => {
        _invalidUpdates[gppKey] = {}
        _.forEach(gp, (gpm, gpmKey) => {
          _invalidUpdates[gppKey]['matches.' + gpm._itemKey] = gpm
        })
      })
      setRepairedMatches(_invalidUpdates)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [matches_combined]);

  useEffect(() => {
    switch (sportsDataMode) {
      case _sdm.sports.seasonResults:
        sportsData_handlers && sportsData_handlers.handleGet_matchesFlatData(matchDate)
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (latestSeason) {
      setCurrentYear(latestSeason)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latestSeason]);

  useEffect(() => {
    if (_matches_flat) {
      convertHelpers.createItemKeys(_matches_flat)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_matches_flat]);

  useEffect(() => {
    if (_matches_flat) {
      const _dateGroupKeyz = sportsHelpers.generateDatesByYear([currentYear], _sportsSeasonType)
      setDateGroupKeyz(_dateGroupKeyz[currentYear])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentYear]);

  useEffect(() => {
    if (matchResultsInfo) {
      sportsSeason_handlers.handleAmmend_mediaMatches(matchResultsInfo)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchResultsInfo]);

  useEffect(() => {
    if (showMatchProp) {
      switch (matchProp) {
        case 'location.name':
          setMode_right(_rightModes_mdu.matchLocations)
          break;
        case 'startTime':
          setMode_right(_rightModes_mdu.matchTime)
          break;
        default:
        // nothing
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showMatchProp]);

  useEffect(() => {
    const form_props = _sportsFormProps[sportsDataMode]
    const _appFormItems = {}
    if (form_props) {
      Object.keys(form_props).forEach(fp => {
        _appFormItems[fp] = newPropEditItem(fp, gEnums.formItemTypes.text, null, null, true)
      })
    }
    setFormProps(form_props)
    setAppFormItems(_appFormItems)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentMenuKey]);

  useEffect(() => {
    const _linkValues = {}
    switch (sportsDataMode) {
      case _sdm.district.updateDistrictSeasonScores:
        const xxx = gls_scores && currentMenuKey && gls_scores[currentMenuKey] ? gls_scores[currentMenuKey] : {}
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = xxx ? xxx[fp] : null
          })
        }
        break;
      default:
        if (formProps) {
          Object.keys(formProps).forEach(fp => {
            _linkValues[fp] = links_score ? links_score[fp] : null
          })
        }
    }
    setLinkValues(_linkValues)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [sportsDataMode, formProps, links_score, currentMenuKey]);


  useEffect(() => {
    if (matches_info && !matchPlayoffPendings) {
      sportsData_handlers.handleSet_matchPlayoffPendings(matchPlayoffPendings_season)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [matchPlayoffPendings_season]);

  const handleSelectedIndex = (selectedIndex) => {
    setSelectedIndex(selectedIndex)
  }

  const sortMatches = (items) => {
    const _matches = _.orderBy(items, [
      item => new Date(item.startDate),
      'level',
      'section',
      'home',
    ]);
    return _matches
  }

  const copyToClipboard = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      console.log("Copied using fallback!");
    } catch (err) {
      console.error("Fallback copy failed", err);
    }
    document.body.removeChild(textarea);
  };

  const handleMode_left = (e, ml) => {
    e && e.stopPropagation()
    setMode_left(ml)
  }

  const handleMode_right = (e, mr) => {
    e && e.stopPropagation()
    let _tabName;
    let _forMedia;
    switch (mr) {
      case _rightModes_mdu.exportStandings:
        _tabName = 'Standings'
        break;
      case _rightModes_mdu.exportResults:
        _tabName = linkValues.scoresSheet
        break;
      case _rightModes_mdu.exportPlayoffResults:
        _tabName = linkValues.playoffScoresSheet
        break;
      case _rightModes_mdu.exportResultsMedia:
        _tabName = linkValues.scoresSheet
        _forMedia = true
        break;
      case _rightModes_mdu.exportPlayoffResultsMedia:
        _tabName = linkValues.playoffScoresSheet
        _forMedia = true
        break;
      default:
      // nothing
    }
    _tabName = _forMedia ? _tabName + ' ' + currentYear + ' Media' : _tabName + ' ' + currentYear + ' Latest'
    setMode_gsTab(_tabName)
    setMode_right(mr)
  }

  const handleCopy = (opts, e) => {
    e && e.stopPropagation()
    switch (mode_right) {
      case _rightModes_mdu.exportStandings:
        const csvs = convertHelpers.convertArrayToCSV(standings_flat, _csvr_results)
        copyToClipboard(csvs)
        break;
      case _rightModes_mdu.exportResults:
        const csv = convertHelpers.convertArrayToCSV(matches_flat_season, _csv_match)
        copyToClipboard(csv)
        break;
      case _rightModes_mdu.exportPlayoffResults:
        const csvp = convertHelpers.convertArrayToCSV(matches_flat_playoff, _csv_matchPlayoff)
        copyToClipboard(csvp)
        break;
      case _rightModes_mdu.exportResultsMedia:
        const csvm = convertHelpers.convertArrayToCSV(matches_flat_season, _csv_match)
        copyToClipboard(csvm)
        break;
      default:
      // nothing
    }
  }

  const handleExport = async (opts, e) => {

    e && e.stopPropagation()

    switch (mode_right) {

      case _rightModes_mdu.exportPlayoffResults:
      case _rightModes_mdu.exportPlayoffResultsMedia:
      case _rightModes_mdu.exportResults:
      case _rightModes_mdu.exportResultsMedia:
      case _rightModes_mdu.exportStandings:

        let items;
        let _tabName;
        let _forMedia;
        let _headers;

        switch (mode_right) {
          case _rightModes_mdu.exportStandings:
            _tabName = 'Standings'
            items = standings_flat && Object.keys(standings_flat).length > 0 ? standings_flat : null
            _headers = _csv_match
            break;
          case _rightModes_mdu.exportResults:
            _tabName = 'Results'
            items = matches_flat_season && Object.keys(matches_flat_season).length > 0 ? matches_flat_season : null
            _headers = _csv_match
            break;
          case _rightModes_mdu.exportPlayoffResults:
            _tabName = 'Playoff Results'
            items = matches_flat_playoff && Object.keys(matches_flat_playoff).length > 0 ? matches_flat_playoff : null
            _headers = _csv_matchPlayoff
            break;
          case _rightModes_mdu.exportResultsMedia:
            _tabName = 'Media Results'
            items = matches_gs && Object.keys(matches_gs).length > 0 ? matches_gs : null
            _headers = _csv_match
            _forMedia = true
            break;
          case _rightModes_mdu.exportPlayoffResultsMedia:
            _tabName = 'Media Playoff Results'
            items = matches_gs && Object.keys(matches_gs).length > 0 ? matches_gs : null
            _headers = _csv_matchPlayoff
            _forMedia = true
            break;
          default:
          // nothing
        }

        if (items) {
          const _matches = sortMatches(items)
          _.forEach(_matches, (m) => {
            if (m.sections) {
              m.sections = _.replace(m.sections, 'section', '')
            }
          })
          setUpdatingGs(true)
          const { values, tabName } = getGoogleSheetDataValues(_matches, _headers, _tabName, currentYear, _forMedia, true)
          await fn_cls.updateGoogleSheetValues(linkValues.googleSheetsId, tabName, values)
          setUpdatingGs(false)
        }
        break;
      default:
      // nothing
    }
  }

  const handleModeLeft = (e, opts) => handleMode_left(e, opts.leftMode)
  const handleModeRight = (e, opts) => handleMode_right(e, opts.rightMode)

  const handleYear = (e, opts) => {
    handleMode_left()
    setCurrentYear(opts.year)
  }

  /**
   * triggers the showing of the right confirmation
   * @param {*} opts 
   * @param {*} e 
   */
  // const handleShow_confirmationResults = (opts, e) => {
  //   handleMode_right(e, _rightModes.confirmResults)
  // }

  // const handleShow_confirmationClearResults = (e) => {
  //   e && e.stopPropagation()
  //   handleMode_right(_rightModes.confirmClearResults)
  // }

  // const handleConfirmation_rankings = (opts, e) => {
  //   e && e.stopPropagation()
  //   handleMode_right(_rightModes.confirmRankings)
  // }

  // This is the MAIN update for the score from the google sheet results
  // uses: seasonalHelpers.updateAllSeasonalMatchesByLevel
  const handleUpdate_gsMatchesSport = (opts, e) => {
    e && e.stopPropagation()
    sportsData_handlers.handleStartUpdate()
    sportsData_handlers.handleUpdate_gsMatchesSport(forPlayoffs)
  }

  const handleTestFunction = (e) => {
    e && e.stopPropagation()
    const cb = (res) => {
      console.log('res', res)
    }
    const data = {
      pojoOnly: false,
      testingOnly: true,
      glsOnly: false,
    }
    fsfn_sports.getSportsDataGlsScores(data, cb)
  }

  const handleAmmend = (e, opts) => {
    e && e.stopPropagation()
    const updatedMatches = _.chain(matches_flat_filtered)
      .filter(match => _.has(match, 'old.startDate'))
      .map(match => _.set(_.clone(match), 'startDate', _.get(match, 'old.startDate')))
      .value();
    const updatedMatches_gs = _.chain(matches_gs)
      .filter(match => _.has(match, 'old.startDate'))
      .map(match => _.set(_.clone(match), 'startDate', _.get(match, 'old.startDate')))
      .value();
  }

  const handleUpdate_repair = (opts, e) => {
    e && e.stopPropagation()
    sportsData_handlers.handleStartUpdate()
    sportsData_handlers.handleUpdate_gsMatchesSport(forPlayoffs, false, repairedMatches)
  }


  const handleUpdate_matchScores = (opts, e) => {
    e && e.stopPropagation()
    const _forceScoresUpdate = true
    const { matches, matches_playoffs } = matches_info
    if (matches) { sportsHelpers.updateSeasonalScoresFromMatches(database_fns, sportPermissions, matches, pathViews, pks_matches_seasonal, false, _forceScoresUpdate) }
    if (matches_playoffs) { sportsHelpers.updateSeasonalScoresFromMatches(database_fns, sportPermissions, matches_playoffs, pathViews, pks_matches_seasonal, true, _forceScoresUpdate) }
  }

  const handleUpdate_gsResultsToMatchDateResults = (opts, e) => {
    const cb = (res) => {
      console.log('res', res)
    }
    e && e.stopPropagation()
    const rtProps = {
      realtimeDocumentType: realtimeDocumentTypes.matchDay,
      sportPermissions,
      sportDataSettings,
      seasonalUpdateType: seasonalUpdateTypes.matches,
      pathViews,
      currentYear,
      matchDayUpdates,
      callback: cb
    }
  }

  const handleClear_matchDayResults = (opts, e) => {
    const cb = () => {
      setUpdatingLocal(false)
    }
    setUpdatingLocal(false)
    realTimeScoring.deleteRealtimeDatabaseScores(mainRt, realtimeDocumentTypes.matchDay, sportPermissions, sportDataSettings, seasonalUpdateTypes.rtMatches, pathViews, _matchDayMatchKeys, null, currentYear, cb)
  }

  const handleBackup_matches = (opts, e) => {
    e && e.stopPropagation()
    const _forceScoresUpdate = true
    const { matches, matches_playoffs } = matches_info
    if (matches) { sportsHelpers.updateSeasonalMatchesFromMatches(database_fns, sportPermissions, matches, pathViews, pks_matches_seasonal, false, _forceScoresUpdate, true) }
    if (matches_playoffs) { sportsHelpers.updateSeasonalMatchesFromMatches(database_fns, sportPermissions, matches_playoffs, pathViews, pks_matches_seasonal, true, _forceScoresUpdate, true) }
  }

  const handleBackup_matchScores = (opts, e) => {
    e && e.stopPropagation()
    const _forceScoresUpdate = true
    const { matches, matches_playoffs } = matches_info
    if (matches) { sportsHelpers.updateSeasonalScoresFromMatches(database_fns, sportPermissions, matches, pathViews, pks_matches_seasonal, false, _forceScoresUpdate, true) }
    if (matches_playoffs) { sportsHelpers.updateSeasonalScoresFromMatches(database_fns, sportPermissions, matches_playoffs, pathViews, pks_matches_seasonal, true, _forceScoresUpdate, true) }
  }

  const handleSend_email = (opts, e) => {
    e && e.stopPropagation()
    const x = matchUpdates_data
    const _allMatches = []
    _.forEach(x, (section) => {
      _.forEach(section, (match) => {
        f
        _allMatches.push(match)
      })
    })

    const matchesWithDate = _allMatches.map(match => ({
      ...match,
      startDateFull: new Date(match.startDate)
    }));


    const _sortedMatches = _.sortBy(matchesWithDate, 'startDateFull');
    let _currentStartDate;

    const _count = _sortedMatches.length

    let emailBody = "Match Results:<br>";
    emailBody += `${'Match Count: '} ${_count}<br>`;

    _.forEach(_sortedMatches, (match) => {
      const { away, home, startDate } = match
      const results = match ? match._results : undefined;
      const { name: name_away } = away
      const { name: name_home } = home
      const { score } = results ?? {}
      if (score) {
        if (_currentStartDate !== startDate) {
          emailBody += `<br>${startDate}<br>`;
          _currentStartDate = startDate
        }
        const { home: home_score, away: away_score } = score
        emailBody += `${name_away} ${away_score} @ ${name_home} ${home_score}<br>`;
        // emailBody += `${startDate}<br>`;
        // emailBody += `Score: ${away_score} - ${home_score}<br><br>`;
      }
    })

    const _recips = []

    if (scoreEmails) {
      _.forEach(scoreEmails, (value) => {
        _recips.push(value.name)
      })
    }

    const notificationData = {
      email: {
        recipient: _recips, //'thumbstatsports@gmail.com',
        subject: 'Scores',
        body: emailBody
      },
      _sender: 'thumbstatsports@gmail.com'
    }
    fn_cls.sendEmail(notificationData)
  }

  const handleUpdate_rankings = (opts, e) => {
    e && e.stopPropagation()
    setShowConfirmation_rankings()
    sportsData_handlers.handleStartUpdate()
    sportsData_handlers.handleUpdate_gsRankings(rankings_info_data)
  }

  const handleGoogleSearch_results = (e, opts) => {
    handleMode_left(e)
    const cb = (res) => {
      sportsData_handlers.handleStopUpdate()
      console.log('res', res)
    }
    sportsData_handlers.handleStartUpdate()
    googleSports.handleGet_gsMatches({ opts, callback: cb })
  }

  const handleMediaSearch_results = (e, opts) => {
    handleMode_left(e)
    if (sportsData_handlers) {
      let _forPlayoffs
      const { fetchMode } = opts
      const gsValues = _.clone(linkValues)
      gsValues.fetchMode = fetchMode
      switch (fetchMode) {
        case _mediaModes.results:
          gsValues.sheetName = linkValues.scoresSheet
          break;
        case _mediaModes.playoffResults:
          gsValues.sheetName = linkValues.playoffScoresSheet
          _forPlayoffs = true
          break;

        default:
        // nothing
      }
      const date = null
      sportsData_handlers.handleStartUpdate()
      sportsData_handlers.handleGet_mediaMatches(date, dateGroupKeyz, _forPlayoffs, currentYear)
    }
  }

  const handleGoogleSearch_rankings = (e) => {
    handleMode_left(e)
    const gsValues = _.clone(linkValues)
    gsValues.googleSheetsId = linkValues.rankingsGoogleSheetsId
    gsValues.sheetName = linkValues.rankingsSheet
    if (sportsData_handlers) {
      sportsData_handlers.handleStartUpdate()
      sportsData_handlers.handleGet_gsRankings(gsValues, currentYear, sportsKey)
    }
  }

  const handleOpenMedia = (e) => {
    e && e.stopPropagation()
    window.open(mediaUrl, '_blank')
  };

  const matchCount = (jsonData) => {
    let _count = 0
    if (jsonData) {
      Object.keys(jsonData).forEach(key => {
        _count += Object.keys(jsonData[key]).length
      })
    }
    return _count
  }

  const handleSelect = (e, item) => {
    if (item) {
    }
  }

  const btn_itemRight = (items, icon_sub, caption, rightMode, disabled, fl) => {
    const occ = (a, b) => {
      const rm = b?.rightMode ? b?.rightMode : a?.rightMode
      setMode_right(rm)
    }
    items.push({ caption, oc: occ, color: 'blue', icon: icon_sub, disabled, opts: { rightMode: rightMode } })
  }

  const item_itemSearch = (items, icon_sub, fetchMode, disabled) => {
    const occ = (e, opts) => {
      handleGoogleSearch_results(e, opts)
    }
    items.push({ caption: _.startCase(fetchMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { fetchMode: fetchMode } })
  }

  const item_itemMediaSearch = (items, icon_sub, fetchMode, disabled) => {
    const occ = (e, opts) => {
      handleMediaSearch_results(e, opts)
    }
    items.push({ caption: _.startCase(fetchMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { fetchMode: fetchMode } })
  }

  const item_itemOpen = (items, icon_sub, openMode, disabled) => {
    const occ = (e, opts) => {
      handleMode_left(e)
      switch (opts.openMode) {
        case _openModes.database:
          openExternal.firebaseDbDirect(pathViews, [_sportCollections._matches_seasonal, pks_matches_seasonal])
          break;
        case _openModes.realtimeDb:
          openExternal.realtimeDb(pathViews)
          break;
        case _openModes.googleSheets:
          openExternal.googleSheets(linkValues.googleSheetsId)
          break;
        case _openModes.media:
          window.open(mediaUrl, '_blank')
          break;
      }
    }
    items.push({ caption: _.startCase(openMode), oc: occ, color: 'blue', icon: icon_sub, fl: true, disabled, opts: { openMode: openMode } })
  }


  const btns_years = () => {
    const items = []
    const _currentYear = new Date().getFullYear();
    const startYear = _currentYear - 6; // 6 years ago
    const endYear = _currentYear + 1;   // Next year 
    // Generate an array of years from startYear to endYear
    const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
    _.forEach(years, (year) => {
      items.push({ caption: year, oc: handleYear, opts: { year: year } })
    })
    return items
  }

  const items_ammend = () => {
    const items = []
    // items.push({ header: 'Adjust', db: true, da: true, icon: 'refresh', })
    items.push({ caption: 'Revert to Old Date', oc: handleAmmend, color: 'teal', fl: true, opts: { rightMode: _rightModes_mdu.exportResults } })
    return items
  }

  const items_exportTo = () => {
    const items = []
    let icon_sub = 'cloud upload';
    // items.push({ header: 'Google Export (' + currentYear + ')', db: true, da: true, icon: 'cloud upload', color: 'purple' })
    btn_itemRight(items, icon_sub, 'Results', _rightModes_mdu.exportResults)
    btn_itemRight(items, icon_sub, 'Playoff Results', _rightModes_mdu.exportPlayoffResults)
    btn_itemRight(items, icon_sub, 'Media Results', _rightModes_mdu.exportResultsMedia)
    btn_itemRight(items, icon_sub, 'Media Playoff Results', _rightModes_mdu.exportPlayoffResultsMedia)
    btn_itemRight(items, icon_sub, 'Standings', _rightModes_mdu.exportStandings)
    return items
  }

  const items_scores = () => {
    const items = []
    let icon_sub = 'arrow right';
    // items.push({ header: 'Scores (' + currentYear + ')', db: true, da: true, icon: 'save', color: 'blue' })
    btn_itemRight(items, icon_sub, 'Update Scores', _rightModes_mdu.confirmScores)
    items.push({ caption: 'Test Functions', oc: handleTestFunction, color: 'teal', fl: true, icon: 'arrow right' })
    return items
  }

  const items_backup = () => {
    const items = []
    let icon_sub = 'arrow right';
    // items.push({ header: 'Backup (' + currentYear + ')', db: true, da: true, icon: 'save', color: 'blue' })
    btn_itemRight(items, icon_sub, 'Backup Matches', _rightModes_mdu.backupMatches)
    btn_itemRight(items, icon_sub, 'Backup Playoff Matches', _rightModes_mdu.backupPlayoffMatches)
    btn_itemRight(items, icon_sub, 'Backup Scores', _rightModes_mdu.backupScores)
    return items
  }

  /**
   * 
   * @returns a list of items that will appear within a menu
   */
  const items_search = () => {
    const items = []
    const items_external = []
    const items_s = []
    const items_media = []
    let icon_ext;
    let icon_search;
    switch (sportsDataMode) {
      case _sdm.sports.seasonResults:
        icon_ext = 'external alternate'
        item_itemOpen(items_external, icon_ext, _openModes.database)
        item_itemOpen(items_external, icon_ext, _openModes.realtimeDb)
        item_itemOpen(items_external, icon_ext, _openModes.googleSheets)
        item_itemOpen(items_external, icon_ext, _openModes.media)

        if (linkValues.scoresSheet) {
          icon_search = 'search'
          item_itemSearch(items_s, icon_search, _fetchModes.results)
          item_itemSearch(items_s, icon_search, _fetchModes.playoffResults)
          item_itemSearch(items_s, icon_search, _fetchModes.resultsMedia)
          item_itemSearch(items_s, icon_search, _fetchModes.playoffResultsMedia)
          item_itemSearch(items_s, icon_search, _fetchModes.wpialResults)
        }

        if (mediaUrl || 1 === 1) {
          item_itemMediaSearch(items_media, icon_search, _mediaModes.results)
          item_itemMediaSearch(items_media, icon_search, _mediaModes.playoffResults)
          // items.push({ caption: 'Date Results', oc: handleMediaSearch_dates, color: 'blue', fl: true })
          // items.push({ caption: 'Playoff Results', oc: handleMediaSearch_playoffs, color: 'blue', fl: true, icon: 'search' })
          // items.push({ caption: 'Refresh Playoff Results', oc: handleRefreshSearch_playoffs, color: 'blue', fl: true })
        }
        break;

      case _sdm.sports.seasonRankings:
        items.push({ caption: 'Search Google Sheets Rankings', oc: handleGoogleSearch_rankings, color: 'blue', icon: 'search', fl: true })
      // items.push({ caption: 'Open Google Sheets', oc: handleOpenGoogleSheets, color: 'orange', icon: appIconTypes.externalAlternate, fl: true })

      default:
        break;

      // nothing
    }
    return { items_external, items_s, items_media }
  }

  const menuItems_left = () => {
    let mis = []
    let items;


    switch (mode_left) {
      case _leftModes.showOptions:
        items = items_all()
        break;
      case _leftModes.showYears:
        items = btns_years()
        break;
      default:
      // nothing
    }

    const hoc = (item) => item?.oc && item.oc(null, item.opts)

    const squares = _.map(items, (item, key) => (
      <ItemMenuSquares menuItems={item.items} caption={_.startCase(item.caption)} icon={item.icon} imsType={_imsTypes.inline} onClick={hoc} />
    ))

    // return <TransitionWrapper >
    //   <ItemMenuSquares menuItems={items_all()} imsType={_imsTypes.inline}  />
    // </TransitionWrapper>

    return <TransitionWrapper>
      {squares}
      {/* <Menu vertical fluid inverted className={'av-menu sd'}>{mis}</Menu> */}
    </TransitionWrapper>
  }

  const items_all = () => {
    // let _allItems;
    const { items_external, items_s, items_media } = items_search()
    const allItems = {
      external: { items: items_external, caption: 'External', icon: 'search' },
      search: { items: items_s, caption: 'Search', icon: 'search' },
      media: { items: items_media, caption: 'Media', icon: 'search' },
      export: { items: items_exportTo(), caption: 'Export', icon: 'search' },
      ammend: { items: items_ammend(), caption: 'Ammend', icon: 'search' },
      scores: { items: items_scores(), caption: 'Scores', icon: 'search' },
      backup: { items: items_backup(), caption: 'Backup', icon: 'search' },
    }
    return allItems
  }

  const button_left = (caption, icon, ml) => <Button
    color='blue'
    size='mini'
    labelPosition='right'
    icon
    onClick={(e) => { handleModeLeft(e, { leftMode: ml }) }}
  >
    <Icon name={icon} />
    {caption}
  </Button>

  const matchDayButton = () => <Button
    color='blue'
    size='mini'
    labelPosition='right'
    icon
    onClick={(e) => { handleModeRight(e, { rightMode: _rightModes_mdu.updatePlayoffMatchDayResults }) }}
  >
    <Icon name='arrow right' />
    Update Gs Results to Match Day Results
  </Button>

  const footer = () => {

    const btns_filter = []

    if (fromApp) {
      switch (selectedIndex) {
        case 0:
          break;
        case 1:
          return;
        case 2:
          return footer_matchDay()
        case 3:
          return footer_pending()
        case 4:
          return footer_results()
        case 5:
          return footer_results()
      }
    }

    return <div className={'header-flex'}>
      <div className='flx2'>
        {button_left('Options', 'options', _leftModes.showOptions)}
        {button_left(currentYear, 'calendar alternate outline', _leftModes.showYears)}
        {matchDayUpdates && matchDayButton()}
      </div>
      <div>
        <UiSaveButtons
          others={btns_filter}
          color={'blue'}
        />
      </div>
    </div>
  }

  let cn = 'match-data-results'
  if (appFormItems && !fromApp) { cn += ' frapp' }
  let headerCount;

  if (filtered_count) {
    headerCount = filterType ? _.startCase(filterType) + ' (' + filtered_count + ')' : 'All (' + filtered_count + ')'
  }

  const teamsList = () => {
    const hc = () => {
      sportsData_handlers.handleShow_matchEdit()
      setMode_right()
    }
    const hs = (t) => {
      sportsData_handlers.handleShow_matchEdit()
      setMode_right()
      const { _itemKey } = matchData_match ?? {}
      const _matchPlayoffPendings = { ...matchPlayoffPendings }
      const matchPending = _matchPlayoffPendings?.[_itemKey]
      const _team = _.pick(t, ['id', 'name', 'sections', 'levels'])
      matchPending.location = _team
      sportsData_handlers.handleSet_matchPlayoffPendings(_matchPlayoffPendings)
    }
    return <TeamList
      handleCancel={hc}
      handleSelect={hs}
      contentOnly={true}
    />
  }

  const matchTime = () => {
    const hc = () => {
      sportsData_handlers.handleShow_matchEdit()
      setMode_right()
    }
    // const handleSetTime = (t) => {
    //   sportsData_handlers.handleShow_matchEdit()
    //   setMode_right()
    //   const { _itemKey } = matchData_match ?? {}
    //   const _matchPlayoffPendings = { ...matchPlayoffPendings }
    //   const matchPending = _matchPlayoffPendings?.[_itemKey]
    //   matchPending.startTime = t.formatted12
    //   sportsData_handlers.handleSet_matchPlayoffPendings(_matchPlayoffPendings)
    // }
    const handleOk = (d, t) => {
      sportsData_handlers.handleShow_matchEdit()
      setMode_right()
      const { _itemKey } = matchData_match ?? {}
      const _matchPlayoffPendings = { ...matchPlayoffPendings }
      const matchPending = _matchPlayoffPendings?.[_itemKey]
      matchPending.startDate = d
      matchPending.startTime = t.formatted12
      sportsData_handlers.handleSet_matchPlayoffPendings(_matchPlayoffPendings)
    }

    return <SportsMatchProvider match={matchData_match} matchKey={matchData_match._itemKey}>
      <SportsEditMatchProvider >
        <MatchDetailsUpdate handleCancel={hc} match={matchData_match} />
      </SportsEditMatchProvider>
    </SportsMatchProvider>
  }


  /**
   * 
   * @returns THIS IS THE CONTENT OF THE RIGHT SIDEBAR!!!
   */
  const content_right = () => {

    const { matches, matches_playoffs } = matches_info

    const _matches = {
      matches: matches,
      matches_playoffs: matches_playoffs,
    }

    const _scores = {
      matches: sportsHelpers.getMatchesScores(matches, 'matches'),
      matches_playoffs: sportsHelpers.getMatchesScores(matches_playoffs, 'playoffMatches'),
      matchDay: 'TEST'
    }

    let wrapperContent;
    let headerCaption;
    let contentData = `Not set for ${mode_right}`;
    let forMedia;

    const btns = []

    headerCaption = _.startCase(mode_right)

    switch (mode_right) {

      case _rightModes_mdu.matchLocations:
        wrapperContent = teamsList()
        break;

      case _rightModes_mdu.matchTime:
        wrapperContent = matchTime()
        break;

      case _rightModes_mdu.confirmMatchDayResults:
        return <MatchesUpdateViewer
          forPlayoffs={forPlayoffs}
          mode_right={mode_right}
        />

      case _rightModes_mdu.confirmClearMatchDayResults:
        contentData = _matchDayMatchKeys
        wrapperContent = <JsonViewer json={_matchDayMatchKeys} />
        btns.push({ caption: 'Clear Match Day Results', oc: handleClear_matchDayResults, icon: 'save', color: 'green' })
        break;

      case _rightModes_mdu.confirmPending:
        return <MatchesUpdateViewer forPlayoffs={true} mode_right={mode_right} />

      case _rightModes_mdu.confirmResults:
        return <MatchesUpdateViewer forPlayoffs={forPlayoffs} mode_right={mode_right} />

      case _rightModes_mdu.confirmClearResults:
        const jsonDataClear = filterType ? matchUpdates_data[filterType] : matchUpdates_data
        const _matchCountClear = matchCount(jsonDataClear)
        headerCaption = 'Update ' + _matchCountClear + ' Matches?'
        wrapperContent = <JsonViewer json={jsonDataClear} name={filterType ? filterType : 'matchDataUpdates'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: _updateStatus_results ? _updateCaption_results : _updateCaption_results + ' (preview)', oc: handleUpdate_gsMatchesSport, icon: 'save', color: _updateStatus_results ? 'green' : 'olive', })
        break;

      case _rightModes_mdu.backupMatches:
        headerCaption = 'Backup Scores?'
        wrapperContent = <JsonViewer json={_matches} name={'seasonMatches'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: _updateStatus_results ? _updateCaption_backupMatches : _updateCaption_backupMatches + ' (preview)', oc: handleBackup_matches, icon: 'save', color: _updateStatus_results ? 'green' : 'olive', })
        break;

      case _rightModes_mdu.backupPlayoffMatches:
        headerCaption = 'Backup Scores?'
        wrapperContent = <JsonViewer json={_matches} name={'playoffMatches'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: _updateStatus_results ? _updateCaption_backupMatches : _updateCaption_backupMatches + ' (preview)', oc: handleBackup_matches, icon: 'save', color: _updateStatus_results ? 'green' : 'olive', })
        break;

      case _rightModes_mdu.backupScores:
        headerCaption = 'Backup Scores?'
        wrapperContent = <JsonViewer json={_scores} name={'seasonScores'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: _updateStatus_results ? _updateCaption_backupScores : _updateCaption_backupScores + ' (preview)', oc: handleBackup_matchScores, icon: 'save', color: _updateStatus_results ? 'green' : 'olive', })
        break;

      case _rightModes_mdu.confirmScores:
        headerCaption = 'Update Scores?'
        wrapperContent = <JsonViewer json={_scores} name={'seasonScores'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: _updateStatus_results ? _updateCaption_scores : _updateCaption_scores + ' (preview)', oc: handleUpdate_matchScores, icon: 'save', color: _updateStatus_results ? 'green' : 'olive', })
        break;

      case _rightModes_mdu.repairResults:
        headerCaption = 'Repair Results?'
        wrapperContent = <JsonViewer json={repairedMatches} name={'repairResults'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: 'Repair Matches', oc: handleUpdate_repair, icon: 'save', color: repairedMatches ? 'green' : 'olive', })
        break;

      case _rightModes_mdu.updatePlayoffMatchDayResults:
        headerCaption = 'Update Gs Results to Match Day Results?'
        wrapperContent = <JsonViewer json={matchDayUpdates} name={'matchDayUpdates'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: "Update Gs Results to Match Day Results", oc: handleUpdate_gsResultsToMatchDateResults, icon: 'copy' })
        break;

      case _rightModes_mdu.confirmRankings:
        const { rankings: jsonDataa } = rankings_info_data ?? {}
        headerCaption = 'Update Rankings?'
        wrapperContent = <JsonViewer json={jsonDataa} name={'rankingUpdates'} ignoreNoMid={_ignoreNoMid} />
        btns.push({ caption: 'Update Rankings', oc: handleUpdate_rankings, icon: 'save', color: 'green' })
        break;

      case _rightModes_mdu.exportResults:
      case _rightModes_mdu.exportPlayoffResults:
      case _rightModes_mdu.exportResultsMedia:
      case _rightModes_mdu.exportPlayoffResultsMedia:
      case _rightModes_mdu.exportStandings:
        let jsonExport;
        switch (mode_right) {
          case _rightModes_mdu.exportStandings:
            jsonExport = standings_flat
            break;
          case _rightModes_mdu.exportResults:
            jsonExport = matches_flat_season
            break;
          case _rightModes_mdu.exportPlayoffResults:
            jsonExport = matches_flat_playoff
            break;
          case _rightModes_mdu.exportResultsMedia:
            jsonExport = matches_flat_season
            break;
          case _rightModes_mdu.exportPlayoffResultsMedia:
            jsonExport = sortMatches(matches_gs)
            break;
        }
        headerCaption = 'Export to (' + mode_gsTab + ')'
        btns.push({ caption: "Copy", oc: handleCopy, icon: 'copy' })
        btns.push({ caption: "Export", oc: handleExport, icon: 'cloud upload', fl: true })
        wrapperContent = <JsonViewer json={jsonExport} name={'Matches'} ignoreNoMid={_ignoreNoMid} />
        break;

      default:
        wrapperContent = <div>???</div>
    }

    return <Wrapper
      header={headerCaption}
      content={wrapperContent}
      contentData={contentData}
      footer={btns && btns.length > 0 && <UiSaveButtons others={btns} />}
      wrapperType={wrapperTypes.paddedHeaderAndFooter}
      updating={updating || updatingLocal}
    />
  }

  const sidebar_left = (visible) => <DataSidebar width={fromApp ? 'wide' : null} direction={'left'} visible={visible} content={visible && menuItems_left()} onHide={handleMode_left} />
  const sidebar_right = (visible) => <DataSidebar width={fromApp ? 'wide' : null} direction={'right'} visible={visible} content={visible && content_right()} onHide={handleMode_right} />

  const footer_matchDay = () => {
    const items = []
    let icon_sub = 'arrow right';
    btn_itemRight(items, icon_sub, 'Clear Match Day', _rightModes_mdu.confirmClearMatchDayResults, _.isEmpty(matchDayMatches))
    btn_itemRight(items, icon_sub, 'Commit Match Day', _rightModes_mdu.confirmMatchDayResults, _.isEmpty(matchDayMatches))
    return <UiSaveButtons
      others={items}
      color={'blue'}
    />
  }

  const footer_pending = () => {
    const items = []
    let icon_sub = 'arrow right';
    btn_itemRight(items, icon_sub, 'Commit Pending', _rightModes_mdu.confirmPending, _.isEmpty(matchPlayoffPendings))
    return <UiSaveButtons
      others={items}
      color={'blue'}
    />
  }

  const footer_results = () => {
    const items = []
    let icon_sub = 'arrow right';
    const _updateDisabled_scores = matchUpdates ? false : true //!gsMatchedRefreshed || !updateAllowed
    btn_itemRight(items, icon_sub, _updateCaption_results, _rightModes_mdu.confirmResults, _updateDisabled_scores)
    return <UiSaveButtons
      others={items}
      color={'blue'}
    />
  }

  const menu_vert_existing = useMemo(() => {
    const count = _counts.matches;
    const _caption = _.startCase('existingMatches') + ': ' + count;
    return (
      <Wrapper
        header={_caption}
        content={
          <LevelSchedules
            _levelDateGroups={levelDateGroups}
            matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.currentMatches}
          />
        }
        wrapperType={wrapperTypes.paddedHeader}
      />
    );
  }, [levelDateGroups]);

  const header_matchDay = (caption) => <div className='header-flex'>
    <div>{caption}</div>
    <div><Icon name='external alternate' color='orange' onClick={(e) => { openExternal.realtimeDb(pathViews) }}></Icon></div>
  </div>

  const menu_vert_missing = useMemo(() => {
    const count = _counts.missing;
    const _caption = _.startCase('missingMatches') + ': ' + count
    return <Wrapper
      header={_caption}
      content={<LevelSchedules matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.missing}></LevelSchedules>}
      wrapperType={wrapperTypes.paddedHeader}
    ></Wrapper>
  }, [missingMatches]);

  const menu_vert_matchDay = useMemo(() => {
    const count = _counts.matches_matchDay;
    const _caption = _.startCase('matchDayMatches') + ': ' + count
    return <Wrapper
      header={header_matchDay(_caption)}
      content={count > 0 ? <LevelSchedules matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.matchDay}></LevelSchedules> : <NoData fullCaption={'None'} />}
      footer={!fromApp && footer_matchDay()}
      wrapperType={count > 0 ? wrapperTypes.paddedHeader : wrapperTypes.padded}
      updating={updatingLocal}
      css={{ content: count === 0 ? 'hwcc' : null }}
    ></Wrapper>
  }, [matchDayMatches]);

  const menu_vert_matchPlayoffPendings = useMemo(() => {
    const count = matchPlayoffPendings ? _.size(matchPlayoffPendings) : 0
    const _caption = _.startCase('matchPlayoffPendings') + ': ' + count
    return <Wrapper
      header={_caption}
      content={count > 0 ? <LevelSchedules matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.pendingMatches}></LevelSchedules> : <NoData fullCaption={'None'} />}
      footer={!fromApp && footer_pending()}
      wrapperType={count > 0 ? wrapperTypes.paddedHeader : wrapperTypes.padded}
      updating={updatingLocal}
      css={{ content: count === 0 ? 'hwcc' : null }}
    ></Wrapper>
  }, [matchPlayoffPendings]);

  const menu_vert_matchUpdates = useMemo(() => {
    const getMs = (_levelDateGroups) => {
      return <LevelSchedules
        _levelDateGroups={_levelDateGroups}
        matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.currentMatches}
      ></LevelSchedules>
    }
    const count = matchUpdates ? _.size(matchUpdates) : 0
    const { _levelDateGroups } = getLevelMatchez(matchUpdates)
    const _caption = _.startCase('updatedMatches') + ': ' + count

    return <Wrapper
      header={_caption}
      content={count > 0 ? getMs(_levelDateGroups) : <NoData fullCaption={'None'} />}
      wrapperType={count > 0 ? wrapperTypes.paddedHeader : wrapperTypes.padded}
      footer={!fromApp && footer_results()}
      css={{ content: count === 0 ? 'hwcc' : null }}
    ></Wrapper >
  }, [matchUpdates]);

  const vwc = () => <WrapperVertCols mvc={'5'} split={fromApp} handleSelectedIndex={handleSelectedIndex}>
    {menu_vert_existing}
    {menu_vert_missing}
    {menu_vert_matchDay}
    {menu_vert_matchPlayoffPendings}
    {menu_vert_matchUpdates}
  </WrapperVertCols>

  const wrapper = () => <Wrapper
    content={vwc()}
    footer={footer()}
    confirmation={confirmation}
    wrapperType={wrapperTypes.paddedHeader}
    updating={updating}
  />

  const sidebar_full = () => <Sidebar.Pushable style={{ overflow: 'hidden' }}>
    {sidebar_left(mode_left ? true : false)}
    {sidebar_right(mode_right ? true : false)}
    <Sidebar.Pusher dimmed={mode_right ? true : false} className={'h100'}>
      {wrapper()}
    </Sidebar.Pusher>
  </Sidebar.Pushable>

  const fullPageWrapper = () => <FullPageWrapper
    content={sidebar_full()}
    topperCaption={_.startCase(sportsDataMode)}
    topperCaption2={_.startCase(filterType)}
    handleCancel={handleCancel}
    css={{ container: 'matchUpdates app-dark-mode' }}
  />

  const content_mda = () => <MatchDataUpdateContext.Provider value={{ sportsData_state, sportsData_handlers }}>
    {forSportsManagement ? sidebar_full() : fullPageWrapper()}
  </MatchDataUpdateContext.Provider>

  return content_mda()
}

export default MatchDataUpdate

